export enum VenueType {
    Undefined = 0,
    LiveEvent = 1,
    Online = 2,
    OnDemand = 3
}
